import Swal, { SweetAlertOptions } from "sweetalert2";
export const defaultOptions = {
  toast: true,
  icon: "success",
  position: "top-right",
  showConfirmButton: false,
  showCloseButton: true,
  timer: 30000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
} as SweetAlertOptions;

const install = (app, options: SweetAlertOptions = {}) => {
  const initializer = (
    overrideOptions: SweetAlertOptions = {}
  ): typeof Swal => {
    options = Object.assign(defaultOptions, options, overrideOptions);

    return Swal.mixin(options);
  };
  app.config.globalProperties.$swal = initializer;

  app.provide("swal", initializer());
};

export default { install };
